import { Action, Dispatch } from "redux";
import { Environments, GetOutputConfigElement, SuccessResponseType } from "@emisgroup/cohort-builder-kit";
import { ProgressSpinnerSlice } from "../../../../ProgressSpinner/Index";
import { OutputConfigSlice } from "../../redux";
import { handleException } from "../../../../../ErrorMessages/helper";
import { OutputConfigResponse, TransformResponseDataType, TransformedOutputElement } from "./Types";

/**
 * Method to transform the output element response
 * @param item Output elements
 * @returns Transformed output element
 */
const transformOutputElement = (item: OutputConfigResponse): TransformedOutputElement => {
  const transformedItem: TransformedOutputElement = {
    configMapId: item?.outputElementGuid,
    configName: item?.outputElementName,
    tag: item.tag,
    sourceReport: item?.sourceArtefact
      ? {
        reportName: item?.sourceArtefact?.artefactName,
        reportId: "",
        reportERN: item?.sourceArtefact?.artefactGuid,
      }
      : undefined,
    includeInOutput: item.includeInOutput,
    outputConfigId: item.outputConfigGuid,
    bandType: item?.bandType || "",
  };

  if (item?.childrenOutputElements) {
    transformedItem.childrenOutputElements = item?.childrenOutputElements?.map(transformOutputElement);
  }

  return transformedItem;
};

/**
 * Method to transform the response data
 * @param sourceData Source data 
 * @returns response Data
 */
const transformResponseData = (sourceData: SuccessResponseType): TransformResponseDataType => {
  const transformedPayload = sourceData?.data?.payload?.outputElements?.map(transformOutputElement);

  return {
    data: {
      type: "OutputConfig",
      payload: {
        outputElements: transformedPayload
      }
    }
  };
};

/**
 * To fetch the config maps list
 */
export const FetchOutputConfigMapsList = async (
  dispatch: Dispatch<Action>,
  // eslint-disable-next-line @typescript-eslint/ban-types
  translate: Function,
  configId: string,
  env: Environments,
  accessToken: string
): Promise<void> => {
  try {
    dispatch(ProgressSpinnerSlice.actions.showProgressBar(translate("LoadingMessage.MappedOutputConfigs")));
    const res = await GetOutputConfigElement(configId, env, accessToken);
    if (res && res["data"]) {
      const mappedOutputConfigs = transformResponseData(res as SuccessResponseType);
      dispatch(OutputConfigSlice.actions.setOutputMappingList(mappedOutputConfigs.data.payload.outputElements));
      dispatch(ProgressSpinnerSlice.actions.hideProgressBar());
    }
  } catch (ex) {
    handleException(ex, dispatch, "GetMappingDetailErrMsg");
  }
};
